import { render, staticRenderFns } from "./SliderFragm.vue?vue&type=template&id=89dd5ad0"
import script from "./SliderFragm.vue?vue&type=script&lang=js"
export * from "./SliderFragm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports